module.exports = __webpack_public_path__ + "static/Jason Fok.cbff45d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Jason Fok.jpg
// module id = 1216
// module chunks = 6166952557895